module.exports = __webpack_public_path__ + "static/img/1.638cc0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/hsyj/1.png
// module id = +yTs
// module chunks = 1